module.exports = __webpack_public_path__ + "img/close-icon.9eb0fa9d.svg";